import SvgIcon from '@mui/material/SvgIcon';
import {FC} from 'react';
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps {
    sx?: SxType
}

const DoubleArrowLeftIcon: FC<IProps> = ({
                                         sx={}
                                     }) => {
    return (
        <SvgIcon
            sx={{

                width:'9px',
                height:'8px',
                fill:'#BEBCB9',
                ...sx,
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 10 8"
            >
                <path
                    d="M4.333 8l-4-4 4-4 .933.933L2.216 4l3.05 3.067L4.333 8zm4.4 0l-4-4 4-4 .933.933L6.616 4l3.05 3.067L8.733 8z"
                ></path>
            </svg>
        </SvgIcon>
    );
};

export default DoubleArrowLeftIcon;